import React, { useState } from 'react';
import { Modal, Button } from '@cimpress/react-components';

import TooltipWrapper from 'src/components/TooltipWrapper';
import CoamDropdown, { CoamResources } from './dropdown';

interface Props {
    tenantType?: string;
    tenantId?: string;
    resources?: CoamResources;
    saveCoam: (data: { type: string; id: string }) => void;
    disabled?: boolean;
    forceShow?: boolean;
    tip?: string;
}

const CoamModal: React.FC<Props> = ({ tenantType, tenantId, resources, saveCoam, disabled, forceShow, tip }) => {
    const [open, setOpen] = useState(forceShow);
    const [trackedForceShow, setTrackedForceShow] = useState(forceShow);
    const [selectedId, setSelectedId] = useState('');
    const [selectedType, setSelectedType] = useState('');

    if (forceShow && !trackedForceShow) {
        setOpen(true);
        setTrackedForceShow(forceShow);
    }

    const onOpen = () => {
        if (!disabled) {
            setOpen(true);
            setSelectedId('');
            setSelectedType('');
        }
    };

    const onClose = () => {
        setOpen(false);
    };

    const onChange = (type: string, id: string) => {
        setSelectedType(type);
        setSelectedId(id);
    };

    const save = () => {
        saveCoam({ type: selectedType, id: selectedId });
        onClose();
    };

    const show = !!open;
    const hasTenantId = !!tenantId;

    return (
        <TooltipWrapper className='coam-tooltip' direction='bottom' contents={tip}>
            <div className='coam__wrapper'>
                <span className='coam__label'>Tenant:</span>
                <button className={`coam-button${disabled ? ' coam-button--disabled' : ''}`} onClick={onOpen}>
                    {tenantId || 'None'}
                </button>
            </div>
            <Modal
                className='coam-modal'
                show={show}
                onRequestHide={onClose}
                closeButton={hasTenantId}
                title='Choose a tenant'
                footer={
                    <div className='coam-modal__footer'>
                        <Button className='coam-modal__close' disabled={!hasTenantId} onClick={onClose}>
                            Cancel
                        </Button>
                        <Button variant='primary' className='coam-modal__submit' disabled={!selectedId} onClick={save}>
                            Save
                        </Button>
                    </div>
                }>
                <div className='coam-modal__description'>
                    Before you begin, you will need to choose which tenant you are designing scenes for. We will
                    remember your choice the next time you come here. You can change this choice from the header.
                </div>
                <CoamDropdown
                    id={selectedId || tenantId}
                    type={selectedType || tenantType}
                    resources={resources}
                    onChange={onChange}
                />
            </Modal>
        </TooltipWrapper>
    );
};

export default React.memo(CoamModal);
